import { db } from '../firebase';
import { ref, update, push, child, get } from "firebase/database";
import { ALL_PRODUCTS } from '../components/data/products';

export const processTaskLogic = async (user, currentTask, isFinalSubmit = false) => {
    if (!user || !currentTask) return;

    const userPath = `users/${user.username}`;
    const updates = {};

    if (isFinalSubmit) {
        if (parseFloat(user.balance) < parseFloat(currentTask.orderAmount)) {
            // "Insufficient Balance" ki jagah lowercase standard translation key throw ki hai
            throw new Error("insufficient_balance");
        }

        const newBalance = (parseFloat(user.balance) + parseFloat(currentTask.commEarned)).toFixed(2);
        const newCompleted = (user.completedTasks || 0) + 1;
        const newLifetimeTasks = (user.lifetimeTasks || 0) + 1;
        const newEarned = (parseFloat(user.earnedCommission || 0) + parseFloat(currentTask.commEarned)).toFixed(2);

        updates[`${userPath}/balance`] = newBalance;
        updates[`${userPath}/completedTasks`] = newCompleted;
        updates[`${userPath}/lifetimeTasks`] = newLifetimeTasks;
        updates[`${userPath}/earnedCommission`] = newEarned;
        updates[`${userPath}/cashGap`] = 0; 
        
        updates[`${userPath}/tasks/${currentTask.id}/status`] = "completed";
        updates[`${userPath}/tasks/${currentTask.id}/completedAt`] = Date.now();
        updates[`${userPath}/pendingTaskActive`] = false; 
    } else {
        const taskId = currentTask.id || push(child(ref(db), `${userPath}/tasks`)).key;
        currentTask.id = taskId;
        
        updates[`${userPath}/tasks/${taskId}`] = {
            ...currentTask,
            status: "pending",
            createdAt: Date.now()
        };
        updates[`${userPath}/pendingTaskActive`] = true;

        // Gap calculation at the start of grab
        const userBalance = parseFloat(user.balance || 0);
        const orderAmt = parseFloat(currentTask.orderAmount);
        
        if (userBalance < orderAmt) {
            const gap = (orderAmt - userBalance).toFixed(2);
            updates[`${userPath}/cashGap`] = `-${gap}`;
        } else {
            updates[`${userPath}/cashGap`] = 0;
        }
    }

    try {
        await update(ref(db), updates);
        return { success: true, taskId: currentTask.id };
    } catch (error) {
        throw error;
    }
};

export const generateRandomTask = async (user) => {
    const trapRef = ref(db, `users/${user.username}/traps/active`);
    const snapshot = await get(trapRef);
    
    let trapTask = null;
    if (snapshot.exists()) {
        const activeTraps = snapshot.val();
        const nextTaskNo = (user.completedTasks || 0) + 1;
        trapTask = Object.values(activeTraps).find(t => parseInt(t.task) === nextTaskNo);
    }

    const productIndex = (user.lifetimeTasks || 0) % ALL_PRODUCTS.length;
    const product = ALL_PRODUCTS[productIndex];
    
    if (trapTask) {
        return {
            ...product,
            id: Date.now().toString(),
            orderAmount: parseFloat(trapTask.amt).toFixed(2),
            commRate: trapTask.rate,
            commEarned: ((parseFloat(trapTask.amt) * parseFloat(trapTask.rate)) / 100).toFixed(2),
            isTrap: true,
            timestamp: Date.now()
        };
    } else {
        const userBalance = parseFloat(user.balance) || 0;

        const orderAmount = parseFloat(
            Math.random() * (userBalance * 0.4) + (userBalance * 0.1) + 10
        ).toFixed(2);

        // ✅ Random commission 2% - 5%
        const randomRate = Math.random() * (5 - 2) + 2;

        const commEarned = (
            (parseFloat(orderAmount) * randomRate) / 100
        ).toFixed(2);

        return {
            ...product,
            id: Date.now().toString(),
            orderAmount,
            commRate: randomRate.toFixed(2),
            commEarned,
            isTrap: false,
            timestamp: Date.now()
        };
    }
};